import ReportItemTransferItem from "../../../../components/@reports/warehouse/ReportItemTransferItem";

import { ReportContextProvider } from "../../../../context/ReportContext";

import { reportScopes, reportTypes } from "../../../../hooks/api/useReports";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { validationSchema, initialValues, advancedValidationSchema, advancedInitialValues } from "../../../../schema/reports/warehouse/itemTransferItemSchema"

export default function ItemTransferItemReport() {

    let routeType = routeTypes.admin

    return (
        <ReportContextProvider
            routeType={routeType}
            reportScope={reportScopes.warehouse}
            reportType={reportTypes.warehouse.itemTransferItem.id}
            validationSchema={validationSchema}
            advancedValidationSchema={advancedValidationSchema}
            initialValues={initialValues}
            advancedInitialValues={advancedInitialValues}
        >
            <ReportItemTransferItem
                routeType={routeType}
            />
        </ReportContextProvider>
    )
}       